export default __webpack_public_path__ + "static/media/q18_05.4f86d52e.png";